<script>
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';
import PreChatFields from './PreChatFields.vue';
import { getPreChatFields, standardFieldKeys } from 'dashboard/helper/preChat';
import WootMessageEditor from 'dashboard/components/widgets/WootWriter/Editor.vue';
export default {
  components: {
    PreChatFields,
    WootMessageEditor,
  },
  props: {
    inbox: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      preChatFormEnabled: false,
      preChatMessage: '',
      preChatFields: [],
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
      customAttributes: 'attributes/getAttributes',
    }),
    preChatFieldOptions() {
      const { pre_chat_form_options: preChatFormOptions } = this.inbox;
      return getPreChatFields({
        preChatFormOptions,
        customAttributes: this.customAttributes,
      });
    },
  },
  watch: {
    inbox() {
      this.setDefaults();
    },
  },
  mounted() {
    this.setDefaults();
  },
  methods: {
    setDefaults() {
      const { pre_chat_form_enabled: preChatFormEnabled } = this.inbox;
      this.preChatFormEnabled = preChatFormEnabled;
      const {
        pre_chat_message: preChatMessage,
        pre_chat_fields: preChatFields,
      } = this.preChatFieldOptions || {};
      this.preChatMessage = preChatMessage;
      this.preChatFields = preChatFields;
    },
    isFieldEditable(item) {
      return !!standardFieldKeys[item.name] || !item.enabled;
    },
    handlePreChatFieldOptions(event, type, item) {
      this.preChatFields.forEach((field, index) => {
        if (field.name === item.name) {
          this.preChatFields[index][type] = !item[type];
        }
      });
    },

    changePreChatFieldFieldsOrder(updatedPreChatFieldOptions) {
      this.preChatFields = updatedPreChatFieldOptions;
    },

    async updateInbox() {
      try {
        const payload = {
          id: this.inbox.id,
          formData: false,
          channel: {
            pre_chat_form_enabled: this.preChatFormEnabled,
            pre_chat_form_options: {
              pre_chat_message: this.preChatMessage,
              pre_chat_fields: this.preChatFields,
            },
          },
        };
        await this.$store.dispatch('inboxes/updateInbox', payload);
        useAlert(this.$t('INBOX_MGMT.EDIT.API.SUCCESS_MESSAGE'), {type: 'success'});
      } catch (error) {
        useAlert(this.$t('INBOX_MGMT.EDIT.API.ERROR_MESSAGE'), {
          type: 'error',
        });
      }
    },
  },
};
</script>

<template>
  <div class="flex flex-col gap-3 bg-n-gray-1 dark:bg-n-vars-br-menu/30">
    <div class=" p-6 rounded-lg flex flex-col">
      <div class="flex gap-3 items-start justify-between">
        <div class="flex flex-col gap-1">
          <h3 class="text-base text-woot-500 dark:text-n-gray-1 mb-0 font-semibold">
            {{ $t('INBOX_MGMT.PRE_CHAT_FORM.ENABLE.LABEL') }}
          </h3>
          <p class="text-base text-slate-700 dark:text-n-gray-5">
            {{ $t('INBOX_MGMT.PRE_CHAT_FORM.DESCRIPTION') }}
          </p>
        </div>
        <woot-submit-button
          class="input-base !bg-n-bluegray-4 !text-white rounded-lg !h-[34px]"
          :button-text="$t('INBOX_MGMT.SETTINGS_POPUP.UPDATE_PRE_CHAT_FORM_SETTINGS')"
          :loading="uiFlags.isUpdating"
          @click="updateInbox"
        />
      </div>

      <form class="flex flex-col" @submit.prevent="updateInbox">
        <label>
          <select v-model="preChatFormEnabled">
            <option :value="true">
              {{ $t('INBOX_MGMT.PRE_CHAT_FORM.ENABLE.OPTIONS.ENABLED') }}
            </option>
            <option :value="false">
              {{ $t('INBOX_MGMT.PRE_CHAT_FORM.ENABLE.OPTIONS.DISABLED') }}
            </option>
          </select>
        </label>
        <div v-if="preChatFormEnabled" class="mt-6">
          <div>
            <label>
              {{ $t('INBOX_MGMT.PRE_CHAT_FORM.PRE_CHAT_MESSAGE.LABEL') }}
            </label>
            <WootMessageEditor
              v-model="preChatMessage"
              class="message-editor"
              :placeholder="
                $t('INBOX_MGMT.PRE_CHAT_FORM.PRE_CHAT_MESSAGE.PLACEHOLDER')
              "
            />
          </div>
          <div class="mt-6">
            <label>{{ $t('INBOX_MGMT.PRE_CHAT_FORM.SET_FIELDS') }}</label>
            <table class="table w-full table-striped woot-table">
              <thead class="thead-dark">
                <tr>
                  <th scope="col" />
                  <th scope="col" />
                  <th scope="col">
                    {{ $t('INBOX_MGMT.PRE_CHAT_FORM.SET_FIELDS_HEADER.KEY') }}
                  </th>
                  <th scope="col">
                    {{ $t('INBOX_MGMT.PRE_CHAT_FORM.SET_FIELDS_HEADER.TYPE') }}
                  </th>
                  <th scope="col">
                    {{
                      $t('INBOX_MGMT.PRE_CHAT_FORM.SET_FIELDS_HEADER.REQUIRED')
                    }}
                  </th>
                  <th scope="col">
                    {{ $t('INBOX_MGMT.PRE_CHAT_FORM.SET_FIELDS_HEADER.LABEL') }}
                  </th>
                  <th scope="col">
                    {{
                      $t(
                        'INBOX_MGMT.PRE_CHAT_FORM.SET_FIELDS_HEADER.PLACE_HOLDER'
                      )
                    }}
                  </th>
                </tr>
              </thead>
              <PreChatFields
                :pre-chat-fields="preChatFields"
                @update="handlePreChatFieldOptions"
                @drag-end="changePreChatFieldFieldsOrder"
              />
            </table>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<style scoped lang="scss">
.message-editor {
  @apply px-3;

  :deep() {
    .ProseMirror-menubar {
      @apply rounded-tl-[4px];
    }
  }
}
</style>
